import { Component, OnInit } from '@angular/core';

import { Router, NavigationEnd } from '@angular/router';
import { EvironmentAPI } from 'src/environments/enviroments.api';

@Component({
  selector: "site-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  repeatFor(n) {
    return Array(n)
      .fill(0)
      .map((f, i) => i);
  }

  folder = "assets/img/home-banner/";

  sliders = [
    // {src, alt, [target, href]}
    {
      src: this.folder + "summit.png",
      alt: "Focus Summit",
      href: "https://www.focusfashionsummit.com.br",
      isVideo: false,
    },
    {
      src: this.folder + "tecido.jpg",
      alt: "Tecidos",
      isVideo: false,
    },
    {
      src: this.folder + "cyber.jpg",
      alt: "Depósito da Cyber Logística",
      isVideo: false,
    },
    {
      src: this.folder + "focus-store.jpg",
      isVideo: false,
      alt: "Focus Store",
      href: "https://www.focus.store/",
    },
  ];

  // videoShowroom = 'https://www.focustextil.com.br/site/videos/showroom.mp4';

  openNewTab(url) {
    if (typeof url === "string") {
      window.open(url, "_blank");
    } else {
      throw new Error('The argument "url" must be String.');
    }
  }

  constructor(private _router: Router) {}

  ngOnInit() {
    this._router.events.subscribe((s) => {
      if (s instanceof NavigationEnd) {
        let tree = this._router.parseUrl(this._router.url);
        if (tree.fragment) {
          this.scroll(tree.fragment);
        }
      }
    });
    window["youtubeIframeFaster"](
      "LukCl49vRiQ",
      { autoplay: 1, loop: 1, mute: 1 },
      function (event) {
        let player = event.player;
        let element = player.f;
        console.log(element);
        let div = document.createElement("div");
        div.setAttribute(
          "style",
          "height: 100%; left: 0; opacity: 0; position: absolute; top: 0; width: 100%;"
        );
        element.parentElement.append(div);
      }
    );
  }

  ngAfterViewInit() {
    // getJSON.js v1
    function getJSON(url, callback) {
      let xhr = new XMLHttpRequest();
      xhr.overrideMimeType("application/json");
      xhr.open("GET", url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
          callback(JSON.parse(xhr.responseText));
        }
      };
      xhr.send(null);
    }

    // pedindo coisas do instagram
    var apiInstagramV2 = EvironmentAPI.instagram_api;
    console.log("API Instagram:", apiInstagramV2);
    const xhr = new XMLHttpRequest();
    xhr.onload = (response) => {
      if (xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        for (let i = 0; i < 3; i++) {
          document
            .querySelector(".instagram a .img" + i + "")
            .setAttribute("src", data[i].imageBase64);
          document
            .querySelector(".instagram .link" + i + "")
            .setAttribute("href", data[i].postUrl);
        }
      } else {
        xhr.open("GET", apiInstagramV2, true);
      }
    };
    xhr.open("GET", apiInstagramV2, true);
    xhr.send();
  }

  scroll(id) {
    var element = document.getElementById(id);
    setTimeout(function () {
      window.scroll({
        top: element.offsetTop + 0,
        left: 0,
        behavior: "smooth",
      });
    }, 300);
  }
}